var map = {
	"./banner-convert-desktop_en.png": 5060,
	"./banner-convert-desktop_zh-cn.png": 7543,
	"./banner-convert-desktop_zh-hk.png": 2983,
	"./banner-convert-mobile_en.png": 6145,
	"./banner-convert-mobile_zh-cn.png": 1061,
	"./banner-convert-mobile_zh-hk.png": 6921,
	"./banner-giftcard-desktop_en.png": 310,
	"./banner-giftcard-desktop_zh-cn.png": 2045,
	"./banner-giftcard-desktop_zh-hk.png": 7636,
	"./banner-giftcard-mobile_en.png": 5908,
	"./banner-giftcard-mobile_zh-cn.png": 9028,
	"./banner-giftcard-mobile_zh-hk.png": 4667,
	"./banner-hkexpress-desktop_en.png": 2182,
	"./banner-hkexpress-desktop_zh-cn.png": 3874,
	"./banner-hkexpress-desktop_zh-hk.png": 9354,
	"./banner-hkexpress-mobile_en.png": 1472,
	"./banner-hkexpress-mobile_zh-cn.png": 5075,
	"./banner-hkexpress-mobile_zh-hk.png": 3614,
	"./banner-shop-desktop_en.png": 4034,
	"./banner-shop-desktop_zh-cn.png": 8869,
	"./banner-shop-desktop_zh-hk.png": 5255,
	"./banner-shop-mobile_en.png": 5830,
	"./banner-shop-mobile_zh-cn.png": 1228,
	"./banner-shop-mobile_zh-hk.png": 1374,
	"./banner-shop-pet-desktop_en.png": 1310,
	"./banner-shop-pet-desktop_zh-cn.png": 4456,
	"./banner-shop-pet-desktop_zh-hk.png": 2394,
	"./banner-shop-pet-mobile_en.png": 8472,
	"./banner-shop-pet-mobile_zh-cn.png": 5136,
	"./banner-shop-pet-mobile_zh-hk.png": 7081,
	"./banner-shop-wine-desktop_en.png": 7977,
	"./banner-shop-wine-desktop_zh-cn.png": 1634,
	"./banner-shop-wine-desktop_zh-hk.png": 2915,
	"./banner-shop-wine-mobile_en.png": 1533,
	"./banner-shop-wine-mobile_zh-cn.png": 4139,
	"./banner-shop-wine-mobile_zh-hk.png": 6225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4838;